/* eslint-disable @typescript-eslint/no-explicit-any */
import { useNavigate, useLocation, useParams, useSearchParams } from 'react-router-dom';

export function useNavigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const goTo = (path: string, options?: { replace?: boolean; state?: any }) => {
    navigate(path, options);
  };

  const goBack = () => {
    navigate(-1);
  };

  const goForward = () => {
    navigate(1);
  };

  const isCurrentPath = (path: string) => {
    return location.pathname === path;
  };

  const getCurrentPath = () => {
    return location.pathname;
  };

  const getSearchParam = (key: string) => {
    return searchParams.get(key);
  };

  const setSearchParam = (key: string, value: string) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set(key, value);
    setSearchParams(newSearchParams);
  };

  const removeSearchParam = (key: string) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.delete(key);
    setSearchParams(newSearchParams);
  };

  return {
    // Navigation functions
    goTo,
    goBack,
    goForward,

    // Location utilities
    isCurrentPath,
    getCurrentPath,
    location,
    params,

    // Search params utilities
    searchParams,
    getSearchParam,
    setSearchParam,
    removeSearchParam,

    // Raw navigate function for advanced use cases
    navigate
  };
}